import { ReactNode } from 'react'

import { StaticImageData } from 'next/image'

import {
  EmajinWhatIsIconsImage,
  EmajinWhatIsImage,
} from 'Assets/Images/Sections/EmajinMembershipsSection'

type Benefit = {
  id: string
  text: string
}

export type EmajinSectionQuestionItem = {
  id: string
  title: string
  subtitle: string
  subtitle2: string
  plainText: ReactNode
  backgroundImage: StaticImageData
  backgroundImageAlt: string
  iconImage: StaticImageData
  iconImageAlt: string
  benefits: Benefit[]
}

export const EMAJIN_SECTION_QUESTION_ITEMS: EmajinSectionQuestionItem[] = [
  {
    id: 'QuestionItem-001',
    title: 'Are you a business owner or c-suite executive?',
    subtitle: 'This is networking with a difference that actually works.',
    subtitle2: "It's networking done the smart way",
    plainText: (
      <>
        This is the perfect room for you to connect with other high-calibre
        business leaders like yourself in an unforced and relaxed format.
      </>
    ),
    backgroundImage: EmajinWhatIsImage,
    backgroundImageAlt: '',
    iconImage: EmajinWhatIsIconsImage,
    iconImageAlt: '',
    benefits: [
      {
        id: 'benefit-001',
        text: 'Getting tired of stale boardrooms and fleeting connections. Play 4.5 hours in a curated group. Build meaningful relationships.',
      },
      {
        id: 'benefit-002',
        text: 'Exclusive or premium golf courses, are just our everyday courses. Tick off all the top courses from your bucket list.',
      },
      {
        id: 'benefit-003',
        text: 'Learn the secrets from industry leading keynote speakers; from listed CEOs to medal winning sports stars.',
      },
      {
        id: 'benefit-004',
        text: 'Access Premier events such as the Rugby League and Cricket Legends golf days.',
      },
    ],
  },
]
